export default "/assets/website/images/download.svg?6d30dad8070e50808e3d4d8fb5fcefe2";